<template>
  <div class="h-100">
    <CardWrapper :has-access="access"  @dblclick="$router.push('/daily')" :is-loading="preloader">
      <template #title>УТРЕННИЙ ОТЧЕТ</template>
      <template #icon><DailyIcon/></template>
        <v-chart
          class="pa-2 "
          style="width: 100%;min-height: 300px;"
          key="ch1"
          v-if="dailyFlights.bar.series.length"
          :option="dailyFlights.bar"
          autoResize
        />
        <div
          class="chart-info-box"
          v-if="!dailyFlights.bar.series.length"
        >
          <v-layout align-center justify-center fill-height column>
            <div class="noChart">
              <v-icon class="light-green--text text--lighten-3">insert_chart_outlined</v-icon>
              <div class="text-xs-center light-green--text">Нет рейсов</div>
            </div>
          </v-layout>
        </div>
      <template #permissionDenied>
        <v-container fluid v-if="!access">
          <div class="text-md-center blue-grey--text">
            <i class="material-icons">warning</i>
            <br />У Вас нет прав доступа для просмотра утренних отчетов!
          </div>
        </v-container>
      </template>
    </CardWrapper>
  </div>
</template>

<script>
import store from '@/store'
import CardWrapper from "../ui/CardWrapper.vue";
import DailyIcon from "../ui/icons/DailyIcon.vue";

export default {
  components: {DailyIcon, CardWrapper},
  data() {
    return {}
  },
  props: ['size', 'needTotal'],
  computed: {
    access: {
      get() {
        return store.getters['chechAccess']('daily')
      },
    },
    // rad: function() {
    //   if (this.size === 'm') {
    //     return ['40%', '60%']
    //   } else if (this.size === 's') {
    //     return ['30%', '50%']
    //   } else if (this.size === 'lg') {
    //     return ['50%', '70%']
    //   } else {
    //     return ['40%', '60%']
    //   }
    // },
    dailyFlights: {
      get() {
        let df = store.getters['daily/getDailyFlights'] // data fields

        function sumArrays(array) {
          const n = array.reduce((max, xs) => Math.max(max, xs.length), 0)
          const result = Array.from({ length: n })
          return result.map((_, i) => array.map(xs => xs[i] || 0).reduce((sum, x) => sum + x, 0))
        }
        const  needTotal = this.needTotal
        function ch(param) {
          let obj = {
            bar: {
              title: {
                text: 'Charts',
                x: 'center',
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow',
                },
                position: function(point, params, dom, rect, size) {
                  return [point[0], point[1]]
                },
              },
              legend: {
                data: [],
                orient: 'horizontal',
                type: 'scroll',
                bottom: '3%',
                left: '3%',
                right: '3%'
              },
              grid: {
                top: '3%',
                left: '3%',
                right: '3%',
                bottom: '15%',
                containLabel: true,
              },
              yAxis: {
                type: 'value',
              },
              xAxis: {
                type: 'category',
                data: [],
              },
              color: [
                '#4caf50',
                '#FF9800',
                '#FF5722',
                '#2196f3',
                '#93A9F4',
                '#749f83',
                '#4CAF50',
                '#bda29a',
                '#6e7074',
                '#546570',
                '#c4ccd3',
              ],
              series: [],
            },
          }

          let seriesArray = []
          let seriesResultsArray = []
          let seriesObject = {
            type: 'bar',
            label: {
              normal: {
                show: true,
                position: 'insideRight',
              },
            },
          }
          // df[param.val].forEach(function (item, i, arr) {
          //   obj.bar.legend.data.push((item.type === '') ? 'П' : item.type)
          //   computedData.push(item.plan)
          // })
          for (let keyRaspName in df) {
            for (let key in df[keyRaspName]) {
              let item = df[keyRaspName][key]
              obj.bar.legend.data.push({
                name: `${keyRaspName}/${key}`,
                icon: 'circle',
              })
              seriesObject.name = `${keyRaspName}/${key}`
              seriesObject.stack = 'all' /* dfKey */
              seriesObject.label = {
                show: true,
                position: 'inside',
                formatter: params => params.value || '',
              }
              item['in'] = item['in'] || {}
              item['out'] = item['out'] || {}
              item['home'] = item['home'] || {}

              seriesObject.data = [
                +item['in'][param.val] || 0,
                +item['out'][param.val] || 0,
                +item['home'][param.val] || 0,
              ]
              seriesArray.push(Object.assign({}, seriesObject))
              seriesResultsArray.push(seriesObject.data)
            }
          }

          let sumSeriesResults = sumArrays(seriesResultsArray)

          obj.bar.series = seriesArray
          obj.bar.xAxis.data = [...new Set(obj.bar.xAxis.data)]

          for (let i = 0; i < sumSeriesResults.length; i++) {
            if (sumSeriesResults[i] != 0 && i == 0) {
              obj.bar.xAxis.data.push('Прилет')
            } else if (sumSeriesResults[i] != 0 && i == 1) {
              obj.bar.xAxis.data.push('Вылет')
            } else if (sumSeriesResults[i] != 0 && i == 2) {
              obj.bar.xAxis.data.push('Домашний')
            }
          }
          if (needTotal) {
            obj.bar.color.unshift('')
            const total = obj.bar.series.reduce((acc, e) => {
              acc[0] += e.data[0]
              acc[1] += e.data[1]
              return acc
            }, [0, 0])
            obj.bar.series.unshift({ name: `Вылет (${total[1]}) / Прилет (${total[0]})`, type: 'bar', stack: 'all' })
            obj.bar.legend.data.unshift({
              name: `Вылет (${total[1]}) / Прилет (${total[0]})`,
            })
          }
          return obj
        }
        return ch({ val: 'plan' })
      },
      set(value) {
        console.log(value);

        store.commit('daily/setDailyFlights', value)
      },
    },
    preloader: {
      get() {
        return store.getters['daily/getPreloader']
      },
      set(value) {
        store.commit('daily/setPreloaderState', value)
      },
    },
  },
  methods: {
    // update: function() {
    //   store.dispatch('daily/updateDailyFlights')
    //   store.dispatch('daily/updateDailyPayload')
    // },
  },
}
</script>

<style scoped>
.noChart i {
  font-size: 110px;
}
.chart-wrapper {
  position: relative;
}
.chart-total {
  position: absolute;
  font-size: 11px;
  top: 30%;
  left: 0;
  z-index: 2;
}
</style>
